"use strict";
exports.__esModule = true;
exports.phoneVerificationRoute = exports.upsertUserAccountRoute = exports.useFindUserAccountRoute = exports.useGetUserAccountRoute = void 0;
var baseUrl = 'v1/user-account';
var useGetUserAccountRoute = function (customerPublicId) { return "".concat(baseUrl, "/").concat(customerPublicId, "/find"); };
exports.useGetUserAccountRoute = useGetUserAccountRoute;
var useFindUserAccountRoute = function (phoneNumber, email) {
    var queryParams = [];
    if (phoneNumber) {
        queryParams.push("phone_number=".concat(encodeURIComponent(phoneNumber)));
    }
    if (email) {
        queryParams.push("email=".concat(encodeURIComponent(email)));
    }
    var queryString = queryParams.join('&');
    return "".concat(baseUrl, "/find").concat(queryString ? "?".concat(queryString) : '');
};
exports.useFindUserAccountRoute = useFindUserAccountRoute;
exports.upsertUserAccountRoute = "".concat(baseUrl, "/upsert");
exports.phoneVerificationRoute = "".concat(baseUrl, "/phone-verification/post");
